import { gql } from '@grandvisionhq/graphql';
import { productFragment } from './fragments/product.js';

const GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS = gql`
  query GetBookAppointmentTryInStoreProducts($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ...ProductFragment
    }
  }
  ${productFragment}
`;

export { GET_BOOK_APPOINTMENT_TRY_IN_STORE_PRODUCTS };
//# sourceMappingURL=get-book-appointment-try-in-store-products.js.map
